import React from 'react';
import { Button } from 'primereact/button';
import PropTypes from 'prop-types';
import './SaveButton.less';

const SaveButton = ({ 
  loading = false,
  disabled = false,
  onClick,
  label = '保存',
  type = 'button',
  className = '',
  iconSrc = 'assets/img/save-setting-icon.svg',
  iconAlt = 'Save',
  ...additionalProps
}) => {
  return (
    <Button
      type={type}
      className={`save-button ${className}`}
      loading={loading}
      disabled={disabled}
      onClick={onClick}
      {...additionalProps}
    >
      <span className="save-icon">
        <img src={iconSrc} alt={iconAlt} />
      </span>
      <span className="save-label">{label}</span>
    </Button>
  );
};

SaveButton.propTypes = {
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  label: PropTypes.string,
  type: PropTypes.string,
  className: PropTypes.string,
  iconSrc: PropTypes.string,
  iconAlt: PropTypes.string,
};

export default SaveButton; 